import { Box } from '@factorialco/deprecated-design-system'
import type {
  PlanningBalancesByPeriodsQuery,
  PlanningBalancesQuery,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import type { ShiftsRow, View } from 'modules/shift_management/lib/types'

import DataTable from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable'
import { ShiftManagementTimeGrid } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid'

type TimePlanningBalance = NonNullable<
  PlanningBalancesQuery['timePlanning']['balancesConnection']['nodes']
>[number]
type TimePlanningBalancesByPeriod = NonNullable<
  PlanningBalancesByPeriodsQuery['timePlanning']['balancesByPeriodsConnection']['nodes']
>[number]

interface BodyProps {
  isLoading: boolean
  shiftsRows: ShiftsRow[]
  view: View
  balancesByEmployee: Record<string, TimePlanningBalance>
  periodBalancesByEmployee: Record<string, TimePlanningBalancesByPeriod[]>
}

const Body = ({
  isLoading,
  shiftsRows,
  view,
  balancesByEmployee: _balancesByEmployee,
  periodBalancesByEmployee: _periodBalancesByEmployee,
}: BodyProps) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()

  if (isLoading) {
    return (
      <Box flexGrow background="grey000White">
        <Loading />
      </Box>
    )
  }

  return hasFeatureFlag('dev_shift_management_shifts_table_abstraction') ? (
    <ShiftManagementTimeGrid
      view={view}
      shiftsRows={shiftsRows}
      balancesByEmployee={_balancesByEmployee}
      periodBalancesByEmployee={_periodBalancesByEmployee}
    />
  ) : (
    <DataTable
      shiftsRows={shiftsRows}
      balancesByEmployee={_balancesByEmployee}
      periodBalancesByEmployee={_periodBalancesByEmployee}
      view={view}
    />
  )
}

export default observer(Body)
